import React from 'react'
import { Icon } from 'react-materialize'
import styled from 'styled-components'
import * as CSS from 'csstype'

type WrappedAlertType = 'success' | 'error'

type WrapperAlertProps = {
  type: WrappedAlertType
  message: string
  className?: string
}

type ColorOverrides = Pick<CSS.Properties, 'backgroundColor' | 'color'>

const error: ColorOverrides = { backgroundColor: '#FF6A6A', color: '#FFADAD' }
const success: ColorOverrides = { backgroundColor: '#0f9d58', color: '#A5E4AE' }

const WrappedAlert: React.FunctionComponent<WrapperAlertProps> = ({
  type,
  message,
  className,
}) => {
  let colors = type === 'success' ? success : error
  const content =
    type === 'success'
      ? { icon: 'done', preMessage: 'Success' }
      : { icon: 'error', preMessage: 'There was an error' }

  return (
    <StyledMessageWrapper {...colors} className={className}>
      <LeftHalfMessage>
        <StyledIconWrapper {...colors}>
          <Icon className={`${type}-icon`}>{content.icon}</Icon>
        </StyledIconWrapper>
      </LeftHalfMessage>
      <RightHalfMessage>
        <PreMessage>{content.preMessage}:</PreMessage>
        <pre>{message}</pre>
      </RightHalfMessage>
    </StyledMessageWrapper>
  )
}

const PreMessage = styled.p`
  color: #4e565c;
`

const LeftHalfMessage = styled.div`
  height: 100%;
  width: 5%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const RightHalfMessage = styled.div`
  width: 100%;
  padding: 1rem;
  background-color: white;
`

const StyledMessageWrapper = styled.div<ColorOverrides>(
  ({ backgroundColor }) => `
  display: flex;
  align-items: center;
  text-align: left;
  color: #b0b8bf;
  height: min-content;
  width: 100%;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  margin: 2rem 1rem;
  background-color: ${backgroundColor};
`
)

const StyledIconWrapper = styled.div<ColorOverrides>(
  ({ color }) => `
  border: 2px solid ${color};
  border-radius: 50%;
  height: 3rem;
  width: 3rem;

  i {
    padding: 1px;
    margin-right: auto;
    margin-left: auto;
    color: ${color};
  }
`
)

export default WrappedAlert
